import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const get_data_luc_hao = async (values) => {
    const res = await axios.post(`${API_URL}luc-hao-report/data-statistics`, values);
    return res;
};

export const get_luc_hao_graphical = async (values) => {
    const res = await axios.post(`${API_URL}luc-hao-report/graphical-statistics`, values);
    return res;
};
